export const getFieldErrors = (field, ruleMessages = {}) => {
    const errors = []

    if (!field || !field.$dirty) return errors

    Object.entries(ruleMessages).forEach(([ruleName, message]) => {
        if (field[ruleName] === undefined) return
        if (!field[ruleName]) errors.push(message)
    })

    return errors
}
